import { render, staticRenderFns } from "./AreaInteresseManage.vue?vue&type=template&id=5affa8e1&scoped=true"
import script from "./AreaInteresseManage.vue?vue&type=script&lang=js"
export * from "./AreaInteresseManage.vue?vue&type=script&lang=js"
import style0 from "./AreaInteresseManage.vue?vue&type=style&index=0&id=5affa8e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5affa8e1",
  null
  
)

export default component.exports